export default __webpack_public_path__ + "static/media/pointofsale.e248e178.svg";